import { Injectable } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { MenuOrientation } from '../../menu/menu-models';

@Injectable({
  providedIn: 'root'
})
export class MainConfigService {

    topbarTheme = 'blue';

    menuTheme = 'light';

    layoutMode = 'light';

    menuMode = 'static';

    inlineMenuPosition = 'bottom';

    inputStyle = 'filled1';

    ripple = true;

    isRTL = false;


    /*****************************Search Begin********************************** */
    searchClick = false;

    search = false;
    /*****************************Search End********************************** */

    /*****************************Topbar Begin********************************** */
    mobileTopbarActive: boolean;

    topbarRightClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: string;
    /*****************************Topbar End********************************** */

    get isDesktop() {
        return window.innerWidth > 991;
    }

    get isMobile() {
        return window.innerWidth <= 991;
    }

    /*****************************Menu Begin********************************** */
    topbarMenuActive: boolean;

    menuActive = true;

    staticMenuDesktopInactive: boolean;

    mobileMenuActive: boolean;

    menuClick: boolean;

    rightMenuActive: boolean;

    currentInlineMenuKey: string;

    inlineMenuActive: any[] = [];

    inlineMenuClick: boolean;

    get isOverlayMenu() {
        return this.menuMode === 'overlay';
    }

    get isStaticMenu() {
        return this.menuMode === 'static';
    }

    get isHorizontalMenu() {
        return this.menuMode === 'horizontal';
    }

    get isSlimMenu() {
        return this.menuMode === 'slim';
    }
    /*****************************Menu End********************************** */

    constructor(private primengConfig: PrimeNGConfig) {}


    onTopbarMobileButtonClick(event) {
        this.mobileTopbarActive = !this.mobileTopbarActive;
        event.preventDefault();
    }

    onRightMenuButtonClick(event) {
        this.rightMenuActive = !this.rightMenuActive;
        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;

        if (this.inlineMenuActive[this.currentInlineMenuKey] && !this.inlineMenuClick) {
            this.inlineMenuActive[this.currentInlineMenuKey] = false;
        }
    }

    onInlineMenuClick(event, key) {
        if (key !== this.currentInlineMenuKey) {
            this.inlineMenuActive[this.currentInlineMenuKey] = false;
        }

        this.inlineMenuActive[key] = !this.inlineMenuActive[key];
        this.currentInlineMenuKey = key;
        this.inlineMenuClick = true;
    }


    onMenuButtonClick(event) {
        this.menuActive = !this.menuActive;
        this.topbarMenuActive = false;
        this.topbarRightClick = true;
        this.menuClick = true;

        if (this.isDesktop) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        } else {
            this.mobileMenuActive = !this.mobileMenuActive;
            if (this.mobileMenuActive) {
                this.blockBodyScroll();
            } else {
                this.unblockBodyScroll();
            }
        }

        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        }
        else {
            this.activeTopbarItem = item;
        }

        if (item === 'search') {
            this.search = !this.search;
            this.searchClick = !this.searchClick;
        }

        event.preventDefault();
    }

    onSearchKeydown(event) {
        if (event.keyCode == 27) {
            this.search = false;
        }
    }


    changeToStaticMenu() {
        this.layoutMode = MenuOrientation.STATIC.toString();
    }

    changeToOverlayMenu() {
        this.layoutMode = MenuOrientation.OVERLAY.toString();
    }

    changeToHorizontalMenu() {
        this.layoutMode = MenuOrientation.HORIZONTAL.toString();
    }

    changeToSlimMenu() {
        this.layoutMode = MenuOrientation.SLIM.toString();
    }





    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }
}
